import Phaser from "phaser";
import {CookSprite} from "./cook_sprite";


export function mouseDirectionFromSprite(pointer: Phaser.Input.Pointer,
                                         cursors: Phaser.Types.Input.Keyboard.CursorKeys,
                                         localSprite: CookSprite) {
    let {mouseOn, mouseLeft, mouseRight, mouseUp, mouseDown} = pointerEvaluationFts(pointer, localSprite);

    let left = (mouseOn && mouseLeft(localSprite)) || cursors.left.isDown
    let right = (mouseOn && mouseRight(localSprite)) || cursors.right.isDown
    let up = (mouseOn && mouseUp(localSprite)) || cursors.up.isDown
    let down = (mouseOn && mouseDown(localSprite)) || cursors.down.isDown
    return {left, right, up, down};
}


function pointerEvaluationFts(pointer: Phaser.Input.Pointer, localSprite: CookSprite) {
    let mouseOn = pointer.isDown

    let mouseLeft = (localSprite) => pointer.worldX < localSprite.x;
    let mouseRight = (localSprite) => pointer.worldX > localSprite.x;
    let mouseUp = (localSprite) => pointer.worldY < localSprite.y;
    let mouseDown = (localSprite) => pointer.worldY > localSprite.y;
    return {mouseOn, mouseLeft, mouseRight, mouseUp, mouseDown};
}